import { useState } from "react";
import { formatKpi } from "@/lib/kpi";

const W = 112;
const H = 36;
const PAD = 4;

/** The last runs of one KPI as a thin line (single series: no legend; the card title names it). Hovering a run shows its value.
 *  Runs with no data leave a gap rather than dropping to zero. */
export function Sparkline({ points, unit, label }) {
  const [hover, setHover] = useState(null);
  const vals = points.map((p) => (p.value === null || p.value === undefined ? null : Number(p.value)));
  const known = vals.filter((v) => v !== null);
  if (known.length < 2) return null;
  const min = Math.min(...known);
  const max = Math.max(...known);
  const span = max - min || 1;
  const step = (W - 2 * PAD) / (points.length - 1);
  const x = (i) => PAD + i * step;
  const y = (v) => H - PAD - ((v - min) / span) * (H - 2 * PAD);
  let d = "";
  vals.forEach((v, i) => { if (v === null) return; d += `${d && vals[i - 1] !== null ? "L" : "M"}${x(i).toFixed(1)},${y(v).toFixed(1)}`; });
  const last = vals.length - 1;
  const at = hover ?? last;
  return (
    <div className="relative shrink-0" onMouseLeave={() => setHover(null)}>
      <svg width={W} height={H} viewBox={`0 0 ${W} ${H}`} role="img" aria-label={`${label}: last ${points.length} runs, from ${formatKpi(known[0], unit)} to ${formatKpi(known[known.length - 1], unit)}`}>
        <path d={d} fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="stroke-slate-500 dark:stroke-slate-400" />
        {vals[at] !== null && <circle cx={x(at)} cy={y(vals[at])} r="3" className="fill-[#910029] stroke-white dark:fill-rose-300 dark:stroke-slate-900" strokeWidth="2" />}
        {points.map((p, i) => (
          <rect key={i} x={x(i) - step / 2} y="0" width={step || W} height={H} fill="transparent" onMouseEnter={() => setHover(i)} />
        ))}
      </svg>
      {hover !== null && (
        <div className="pointer-events-none absolute -top-8 right-0 whitespace-nowrap rounded-md bg-slate-900 px-2 py-1 text-[11px] text-white shadow dark:bg-slate-100 dark:text-slate-900">
          {formatKpi(vals[hover], unit)} · {new Date(points[hover].computed_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short" })}
        </div>
      )}
    </div>
  );
}
